<template>
  <div
    class="modal"
    :class="{ 'is-active': value }">

    <div class="modal-background"
      @click="close()">
    </div>
    
    <div class="modal-content">

      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">
            Assign Task to Workstation
          </p>
          <button
            class="delete"
            aria-label="close"
            @click="close()">
          </button>
        </header>

        <v-form 
          class="modal-card-body" 
          :valid.sync="valid">

          <div class="columns" v-if="task">
            <div class="column is-half">
              <label class="label">
                Task Type
              </label>
              <div>
                {{ task.step.work_name }}
              </div>
            </div>
            <div class="column is-half">
              <label class="label">
                Total Quantity Needed
              </label>
              <div>
                {{ task.qty_unassigned - taskAssignment.qty_assigned }}
              </div>
            </div>    
          </div>

          <div class="columns">
            <div class="column is-half">
              <label class="label">Workstation*</label>
              <v-select
                required
                :options="workstations"
                item-text="workstation_name"
                item-value="id"
                v-model="taskAssignment.workstation_id"
              />
            </div>
            <div class="column is-half">
              <label class="label">Quantity Assigned*</label>
              <v-text-field 
                required
                type="number"
                placeholder="Quantity to assign"
                :rules="qtyAssignmentRules"
                v-model="taskAssignment.qty_assigned"
              />
            </div>
          </div>

        </v-form>

        <footer class="modal-card-foot">
          <button 
            :disabled="!valid"
            class="button is-primary" 
            @click.stop="addTask()">
            Save
          </button>
          <button 
            class="button" 
            @click.stop="close(true)">
            Cancel
          </button>
        </footer>

      </div>
    </div>
  </div>
</template>

<script>
import VForm from '@/components/base/VForm'
import VSelect from '@/components/base/VSelect'
import VTextField from '@/components/base/VTextField'

import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  components: { VForm, VSelect, VTextField },
  props: {
    value: {
      type: Boolean
    },
    task: {
      type: Object
    }
  },
  data() {
    return {
      taskAssignment: {
        master_production_step_id: null,
        qty_assigned: null,
        workstation_id: null
      },
      valid: false
    }
  },
  computed: {
    ...mapState("workstations", ["workstations"]),
    ...mapGetters("masterProductions", ["masterProductionIds"]),
    qtyAssignmentRules() {
      return [
        (v) => v <= this.task.qty_unassigned || 'Quantity assigned cannot be greater than quantity available'
      ]
    }
  },
  created() {
    this.initialize();
  },
  methods: {
    ...mapActions("workstations", ["getWorkstations"]),
    ...mapActions("masterProductions", ["refreshMasterProduction"]),
    ...mapActions("workstationQueues", ["addWorkstationTask"]),
    initialize() {
      if (this.workstations.length == 0) {
        this.getWorkstations({ per_page: 1000 });
      }
    },
    addTask() {
      this.taskAssignment.master_production_step_id = this.task.id;
      this.addWorkstationTask(this.taskAssignment).then(
        () => {
          if (this.masterProductionIds.includes(this.task.master_production_id)) {
            this.refreshMasterProduction(this.task.master_production_id);
          }
          this.close(true);
        }
      )
    },
    close(clear=false) {
      this.$emit('input', false);
      if (clear) {
        this.clearData();
      }
    },
    clearData() {
      Object.assign(this.$data, this.$options.data.call(this));
    }
  }
}
</script>